module.exports = __webpack_public_path__ + "fonts/AmbulatoriaD-Regular.f41d1736.woff2";